var _title, _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_search_24px")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.644,17.022 L13.94,13.157 C14.982,11.774 15.609,10.034 15.609,8.143 C15.609,3.653 12.108,0 7.805,0 C3.501,0 0,3.653 0,8.143 C0,12.632 3.501,16.285 7.805,16.285 C9.491,16.285 11.05,15.717 12.328,14.765 L16.067,18.667 C16.285,18.894 16.57,19.007 16.856,19.007 C17.141,19.007 17.426,18.894 17.644,18.667 C18.079,18.213 18.079,17.477 17.644,17.022 L17.644,17.022 Z M2.229,8.143 C2.229,4.936 4.731,2.327 7.805,2.327 C10.879,2.327 13.379,4.936 13.379,8.143 C13.379,11.35 10.879,13.958 7.805,13.958 C4.731,13.958 2.229,11.35 2.229,8.143 L2.229,8.143 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/search",
    transform: "translate(-3.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_search_24px",
    transform: "translate(3.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c/#000000/1",
    mask: "url(#mask-2)",
    fill: "#8c9ea7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search.03f0157d.svg";
export { ForwardRef as ReactComponent };